import { isFreeTrialUsed } from 'utils/freeVersionBlock'
import { MIXPANEL_PROPS } from 'utils/mixpanel'

export const getBuyPurchaseType = (
  plan: string,
  isBlackList = false,
  isRestart = false,
) => {
  if (isRestart) {
    return MIXPANEL_PROPS.PURCHASE_TYPE.values.WIN
  }

  const haveFreeTrial = !isFreeTrialUsed()
  if (haveFreeTrial && (['lifetime', 'yearly'].includes(plan) || isBlackList)) {
    return MIXPANEL_PROPS.PURCHASE_TYPE.values.WIN
  }

  if (haveFreeTrial) {
    return MIXPANEL_PROPS.PURCHASE_TYPE.values.START_TRIAL
  }

  return MIXPANEL_PROPS.PURCHASE_TYPE.values.WIN
}

const extractNumber = (str: string) => {
  const match = str.match(/\d+/)
  return match ? parseInt(match[0], 10) : 0
}

const transformPlanIntoNumber = (plan: string) => {
  if (plan === 'monthly') {
    return 1
  }
  if (plan === 'yearly') {
    return 2
  }
  return 3
}

export const getUpdatePlanPurchaseType = (
  oldPlan: string,
  newPlan: string,
  oldTier: string,
  newTier: string,
) => {
  const oldTierNumber = extractNumber(oldTier)
  const newTierNumber = extractNumber(newTier)
  const oldPlanNumber = transformPlanIntoNumber(oldPlan)
  const newPlanNumber = transformPlanIntoNumber(newPlan)

  if (oldTierNumber === newTierNumber) {
    if (oldPlanNumber < newPlanNumber) {
      return MIXPANEL_PROPS.PURCHASE_TYPE.values.UPSELL
    }
    if (oldPlanNumber > newPlanNumber) {
      return MIXPANEL_PROPS.PURCHASE_TYPE.values.DOWNSELL
    }
  }

  if (oldPlanNumber === newPlanNumber) {
    if (oldTierNumber < newTierNumber) {
      return MIXPANEL_PROPS.PURCHASE_TYPE.values.UPGRADE
    }
    if (oldTierNumber > newTierNumber) {
      return MIXPANEL_PROPS.PURCHASE_TYPE.values.DOWNGRADE
    }
  }

  if (oldPlanNumber < newPlanNumber && oldTierNumber < newTierNumber) {
    return MIXPANEL_PROPS.PURCHASE_TYPE.values.UPGRADE_UPSELL
  }

  if (oldPlanNumber > newPlanNumber && oldTierNumber < newTierNumber) {
    return MIXPANEL_PROPS.PURCHASE_TYPE.values.UPGRADE_DOWNSELL
  }

  if (oldPlanNumber > newPlanNumber && oldTierNumber > newTierNumber) {
    return MIXPANEL_PROPS.PURCHASE_TYPE.values.DOWNGRADE_DOWNSELL
  }

  if (oldPlanNumber < newPlanNumber && oldTierNumber > newTierNumber) {
    return MIXPANEL_PROPS.PURCHASE_TYPE.values.DOWNGRADE_UPSELL
  }

  return MIXPANEL_PROPS.PURCHASE_TYPE.values.DOWNGRADE_DOWNSELL
}
